import { ICommunityCategory } from './Community';
import { enrichThinProfile, IThinProfile } from './ThinProfile';
import { enrichUser, IUser } from './User';

export interface ICommunityPostImage {
  id: string;
  large_image_url: string;
  thumbnail_image_url: string;
}

export interface ICommunityPostFile {
  id: string;
  url: string;
  filename: string;
  size: number;
}

export interface ICommunityPost {
  id: string;
  type: 'community_posts';
  title: string;
  description: string;
  created_at: string;
  last_activity_at: string;
  likes_count: number;
  comments_count: number;
  pinned: boolean;
  meta?: { followed?: boolean; liked?: boolean; new_comments_count?: number };
  images: Array<ICommunityPostImage>;
  files: Array<ICommunityPostFile>;
  // Relationships (resolved by kitsu-core)
  visible_categories?: Array<ICommunityCategory>;
  user?: IUser;
  last_activity_profile?: IThinProfile;
}

export function enrichCommunityPost(post: ICommunityPost): ICommunityPost {
  return {
    ...post,
    images: post.images ?? [],
    files: post.files ?? [],
    visible_categories: post.visible_categories ?? [],
    user: post.user ? enrichUser(post.user) : undefined,
    last_activity_profile: post.last_activity_profile ? enrichThinProfile(post.last_activity_profile) : undefined,
  };
}
